import { render, staticRenderFns } from "./demoIndex.vue?vue&type=template&id=b3a10760&"
import script from "./demoIndex.vue?vue&type=script&lang=js&"
export * from "./demoIndex.vue?vue&type=script&lang=js&"
import style0 from "./demoIndex.vue?vue&type=style&index=0&id=b3a10760&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports